import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomDeepSearchOutlined = createSvgIcon(
  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="M8 12c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4m5-8.94c4.17.46 7.48 3.77 7.94 7.94H22c.55 0 1 .45 1 1s-.45 1-1 1h-1.06A8.994 8.994 0 0 1 13 20.94V22c0 .55-.45 1-1 1s-1-.45-1-1v-1.06A8.994 8.994 0 0 1 3.06 13H2c-.55 0-1-.45-1-1s.45-1 1-1h1.06A8.994 8.994 0 0 1 11 3.06V2c0-.55.45-1 1-1s1 .45 1 1zM5 12c0 3.87 3.13 7 7 7s7-3.13 7-7-3.13-7-7-7-7 3.13-7 7m7 1.565a1.565 1.565 0 1 0 0-3.13 1.565 1.565 0 0 0 0 3.13"
  />,
  'CustomDeepSearchOutlined',
);

export default CustomDeepSearchOutlined;
